import { EnvironmentProfile } from './interfaces';

export const profiles: Record<string, EnvironmentProfile> = {
  local: {
    name: 'local',
    api: 'http://localhost:4200',
    url: 'http://localhost:4200',
    msalConfig: {
      auth: {
        clientId: '5279e680-a4cf-4af8-9dea-48b29af42352',
        authority: 'https://login.microsoftonline.com/7849ae70-f969-4dae-a3eb-fcefa4b60df1',
      },
    },
  },
  entwicklung: {
    name: 'entwicklung',
    api: 'https://ent.art.aida.compeople.dev',
    url: 'https://ent.art.aida.compeople.dev',
    msalConfig: {
      auth: {
        clientId: '5279e680-a4cf-4af8-9dea-48b29af42352',
        authority: 'https://login.microsoftonline.com/7849ae70-f969-4dae-a3eb-fcefa4b60df1',
      },
    },
  },
  integration: {
    name: 'integration',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
  abnahme: {
    name: 'abnahme',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
  produktion: {
    name: 'produktion',
    api: '',
    url: '',
    msalConfig: {
      auth: {
        clientId: '',
        authority: '',
      },
    },
  },
};
